export default __webpack_public_path__ + "static/media/evcharger2.9b8607c6.jpg";